import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';
import { Rect } from 'react-native-svg';

export const StepICon: React.FC<React.PropsWithChildren<SvgProps>> = props => (
  <Svg width={props.size || 8} height={props.size || 8} viewBox="0 0 24 24" fill="none">
    <Rect width={24} height={24} rx={12} fill={props.fill} />
    <SvgPath
      d="M10.0001 14.78L7.2201 12L6.27344 12.94L10.0001 16.6667L18.0001 8.66668L17.0601 7.72668L10.0001 14.78Z"
      fill="white"
    />
  </Svg>
);
